import { MappingStatus, RuleApplyStatus } from '@types'

import { MAPPING_STATUS_LABELS, MAPPING_STATUS_COLORS, RULE_APPLY_STATUS_NOTIFICATION_TYPES, RULE_APPLY_STATUS_MESSAGES, RULE_CREATION_STATUS_MESSAGES } from './const'

export const getMappingStatusLabel = (status?: MappingStatus | null): string => {
  if (!status) return 'Not Mapped'
  return MAPPING_STATUS_LABELS[status] || 'Unknown Status'
}

export const getMappingStatusColor = (status?: MappingStatus | null): string => {
  if (!status) return 'gray'
  return MAPPING_STATUS_COLORS[status] || 'gray'
}

export const getRuleApplyStatusMessage = (status: RuleApplyStatus): string => {
  return RULE_APPLY_STATUS_MESSAGES[status] || 'Rule processing completed.'
}

export const getRuleApplyNotificationType = (status: RuleApplyStatus): 'success' | 'error' | 'warn' => {
  return RULE_APPLY_STATUS_NOTIFICATION_TYPES[status] || 'success'
}

export const getRuleCreationStatusMessage = (status?: RuleApplyStatus | null): string => {
  if (!status || status === RuleApplyStatus.NOT_APPLIED) {
    return 'Rule created successfully.' // Default message
  }
  return RULE_CREATION_STATUS_MESSAGES[status] || 'Rule created successfully.'
}

export const getRuleCreationNotificationType = (status?: RuleApplyStatus | null): 'success' | 'error' | 'warn' => {
  if (!status || status === RuleApplyStatus.NOT_APPLIED) {
    return 'success' // Default to success for creation
  }
  return RULE_APPLY_STATUS_NOTIFICATION_TYPES[status] || 'success'
}
